import React from 'react';
import clx from 'classnames';
import './MessageBanner.scss';
import { ContainerFront } from '../layout/ContainerFront';

export interface MessageBannerProps {
  children: React.ReactNode;
  type?: 'success' | 'info' | 'warning' | 'error';
}

/**
 * Benner fisso per messaggi
 */
export function MessageBanner(props: MessageBannerProps) {
  return (
    <div
      className={clx('message-banner', `type-${props.type ?? 'warning'}`, {})}
    >
      <ContainerFront>{props.children}</ContainerFront>
    </div>
  );
}
